import type { NoteItem as NoteItemType } from '@webforge-survey/shared';

/**
 * Item de type "note" : pas d'input, juste un texte affiché. Sert pour les
 * encarts d'information (ressources, transitions de bloc, rappels).
 *
 * Pas de `fieldset` (pas d'input), juste un encart calme.
 */
interface NoteItemProps {
  item: NoteItemType;
}

export function NoteItem({ item }: NoteItemProps) {
  return (
    <div
      className="info-callout max-w-prose"
      id={`item-${item.name}`}
      role="note"
    >
      {item.label.split('\n').map((line, i) => (
        <p key={i} className={i > 0 ? 'mt-2' : ''}>
          {line}
        </p>
      ))}
      {item.hint && (
        <p className="text-sm text-text-muted mt-3">{item.hint}</p>
      )}
    </div>
  );
}
